import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import EditPlayerOverlay from './EditPlayer';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faStar } from '@fortawesome/free-solid-svg-icons';
// import { faEdit } from '@fortawesome/free-solid-svg-icons';
import './DetailCard.css'; // Assuming you have a CSS file for styles

const DetailCard = ({ handleGetPlayers, teamId, v }) => {
  const [editPlayerVisible, setEditPlayerVisible] = useState(false);
  const history = useHistory();

  const toggleEditPlayer = () => {
    setEditPlayerVisible(!editPlayerVisible);
  };

  return (
    <div className="detail-card">
      

      <div className="player-data-row" onClick={toggleEditPlayer}>
        <span className="homejer">{v.homeJersey}</span>
        <span className="player-txt" title={v.playerName}>
          {v.playerName}
        </span>
        {/* {v.isCaptain === 'true' ? (
          <FontAwesomeIcon
            icon={faStar}
            style={{ marginLeft: '-12px', color: 'red', fontSize: '14px' }}
          />
        ) : (
          <div style={{ width: '14px' }} />
        )} */}
        <button className="edit-button" onClick={toggleEditPlayer}>
          {/* <FontAwesomeIcon icon={faEdit} style={{ fontSize: '18px', color: 'transparent' }} /> */}
        </button>
        <span className="homejer">{v.awayJersey}</span>
      </div>

      {editPlayerVisible && (
        <EditPlayerOverlay
          onBackdropPress={() => toggleEditPlayer(false)}
          isVisible={editPlayerVisible}
          handleGetPlayers={handleGetPlayers}
          teamId={teamId}
          data={v}
          history={history}
        />
      )}
    </div>
  );
};

export default DetailCard;
